import script from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"

import "./ScreenTitle.vue?vue&type=style&index=0&id=02d3ac4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d3ac4a"]])

export default __exports__